import React from 'react'

import e1 from '../img/eee1.png'
import ee2 from '../img/ee2.png'
import ee3 from '../img/ee3.png'
import ee4 from '../img/ee4.png'
import ee5 from '../img/ee5.png'
import ee6 from '../img/ee6.png'
import ee7 from '../img/ee7.png'
import ee8 from '../img/ee8.png'
import ee9 from '../img/ee9.png'
import ee10 from '../img/ee10.png'








import Carousel, { consts } from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faLeftLong , faRightLong } from '@fortawesome/free-solid-svg-icons';

function MobileExample() {
    const row1 = [
        {
          id: 1,
          img: e1,
          title: "roshn",
          link: "https://www.roshn.sa/ar"
        },
        {
            id: 2,
            img: ee2,
            title: "anb",
            link: "https://anb.com.sa/ar/web/anb"
          },
          {
            id: 3,
            img: ee3,
            title: "sukuk",
            link: "https://sukuk.sa/"
          },
          {
            id: 4,
            img: ee4,
            title: "saudia",
            link: "https://www.saudia.com/ar-SA"
          },
          {
            id: 5,
            img: ee5,
            title: "almatar",
            link: "https://almatar.com/ar/"
          },
          {
            id: 6,
            img: ee6,
            title: "flynas",
            link: "https://www.flynas.com/ar"
          },
          {
            id: 7,
            img: ee7,
            title: "flynas",
            link: "https://ar.airbnb.com/?from_belo_click"
          },
          {
            id: 8,
            img: ee8,
            title: "elknafa",
            link: "https://elknafa.com/"
          },
          {
            id: 9,
            img: ee9,
            title: "binaya",
            link: "https://binaya-sa.com/"
          },
          {
            id: 10,
            img: ee10,
            title: "binaya",
            link: "https://binaya-sa.com/"
          },
      ]
    
      const responsive = {
        superLargeDesktop: {
          // screens larger than 1920px
          breakpoint: { max: 4000, min: 1920 },
          items: 3
        },
        desktop: {
          // screens larger than 1024px
          breakpoint: { max: 1920, min: 1024 },
          items: 3
        },
        tablet: {
          // screens larger than 464px
          breakpoint: { max: 1024, min: 464 },
          items: 2
        },
        mobile: {
          // screens smaller than 464px
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
      };
    
      const CustomButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
        const { carouselState: { currentSlide } } = rest;
        return (
          <div className="custom-button-group">
            <button onClick={() => previous()} className="custom-arrow left">
            <FontAwesomeIcon icon={faRightLong} className='exampleicon'/>
             </button>
            <button onClick={() => next()} className="custom-arrow right">
            <FontAwesomeIcon icon={faLeftLong} className='exampleicon'/>
              </button>
          </div>
        );
      };
  return (
    <div className='example2 example'>
    <div className="container">
      <Carousel 
        responsive={responsive} 
        autoPlay={true}
        autoPlaySpeed={6000}
        infinite={true}
        customButtonGroup={<CustomButtonGroup />}
        renderButtonGroupOutside={true}
        arrows={false}
        className='m--20'
      >
        {row1.map((item, index) => (
          <div key={index} className="mockup mockup-macbook m-4">
                <a href={item.link} target='_blank' rel="noopener noreferrer">
                  <img src={item.img} alt={item.title} className='imgexample d-block mx-auto' />
                </a>
              </div>
        ))}
      </Carousel>
    </div>
  </div>
  )
}

export default MobileExample
